import { endpoints, request } from '!core/api';

export const trlInsertOrderServices = {
  validateOrder: ({ publicOfferId, trancheId, quantity, price }) =>
    request.get(
      endpoints.backoffice(
        `WsbValidateOrder?publicOfferId=${publicOfferId}&trancheId=${trancheId}&quantity=${
          quantity ?? ''
        }&price=${price ?? ''}`,
      ),
    ),
  orderComissions: ({
    clientId,
    cashAccount,
    securityExchange,
    securityType,
    symbol,
    orderQty,
    currency,
    price,
    stopPx,
    side = 1,
  }) =>
    request.get(
      endpoints.simo(
        `orderComissions?clientId=${clientId}&cashAccount=${cashAccount}&securityExchange=${securityExchange}&securityType=${securityType}&symbol=${symbol}&orderQty=${
          orderQty ?? ''
        }&currency=${currency}&price=${price ?? ''}&stopPx=${
          stopPx ?? ''
        }&side=${side}`,
      ),
    ),
  insertOrder: ({
    simulationId,
    operation,
    clientId,
    cashAccount,
    securityExchange,
    securityType,
    symbol,
    ordType,
    side,
    orderQty,
    currency,
    price,
    stopPx,
    timeInForce,
    expireTime,
    confirmSeq,
  }) =>
    request.post(endpoints.simo('simpleOrder'), {
      simulationId,
      operation,
      clientId,
      cashAccount,
      securityExchange,
      securityType,
      symbol,
      ordType,
      side,
      orderQty,
      currency,
      price,
      stopPx,
      timeInForce,
      expireTime,
      confirmSeq,
    }),
  cancelOrder: ({ clientId, ordBookKey, text }) =>
    request.put(endpoints.simo('cancelOrder'), {
      clientId,
      ordBookKey,
      text,
    }),
  replaceOrder: ({
    simulationId,
    operation,
    ordBookKey,
    orderQty,
    ordType,
    price,
    timeInForce,
    stopPx,
    clientId,
    expireTime,
    confirmSeq,
  }) =>
    request.put(endpoints.simo('replaceOrder'), {
      simulationId,
      operation,
      ordBookKey,
      orderQty,
      ordType,
      price,
      timeInForce,
      stopPx,
      clientId,
      expireTime,
      confirmSeq,
    }),
};
